import React, { Component } from "react";
import ImageCard from "../imagecard";

export default class RugPartsPanelItems extends Component {
  isLoading = (activeTab) => {
    switch (activeTab) {
      case "border":
        return this.props.globalState.borderItemsLoading;
      case "corner":
        return this.props.globalState.cornerItemsLoading;
      case "toranj":
        return this.props.globalState.toranjItemsLoading;
      case "tile":
        return this.props.globalState.tileItemsLoading;
      case "background":
        return this.props.globalState.backgroundItemsLoading;
      case "afshan_background":
        return this.props.globalState.kheshtiBackgroundItemsLoading;
      case "kheshti_background":
        return this.props.globalState.kheshtiBackgroundItemsLoading;
      case "modern_background":
        return this.props.globalState.modernBackgroundItemsLoading;
      default:
        return false;
    }
  };

  constructor(props) {
    super(props);
    this.state = {
      parts: [],
      loading: true,
    };
  }

  render() {
    let items = this.props.items.map((item) => {
      if (
        !item.rug_types ||
        item.rug_types.length === 0 ||
        item.rug_types.indexOf(this.props.rugType) >= 0
      ) {
        return (
          <ImageCard
            key={item.id + item.name + this.props.rugType}
            item={item}
            partSelectHandler={this.props.partSelectHandler}
          />
        );
      }
      return null;
    });
    return (
      <div
        className="d-flex slide-your-rug"
        onTouchMove={this.props.handleScroll}
      >
        {items}
        {this.isLoading(this.props.globalState.activePartsTab) && (
          <p>{this.props.texts.receiving_information}...</p>
        )}
        {!this.isLoading(this.props.globalState.activePartsTab) &&
          this.props.items.length < 1 && (
            <p>متاسفانه طرحی برای این بخش وجود ندارد!</p>
          )}
      </div>
    );
  }
}
